import { render, staticRenderFns } from "./thirdaccesstable.vue?vue&type=template&id=582ffac2&scoped=true&"
import script from "./thirdaccesstable.vue?vue&type=script&lang=js&"
export * from "./thirdaccesstable.vue?vue&type=script&lang=js&"
import style0 from "./thirdaccesstable.vue?vue&type=style&index=0&id=582ffac2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582ffac2",
  null
  
)

export default component.exports